import React, { useId, useLayoutEffect, useState } from "react";
import { twMerge } from "tailwind-merge";
import cn from "classnames";
import { assert } from "../../util";
import usePrevious from "../../hooks/usePrevious";
const ExpandableRow = (props) => {
    const { children, expand, isOpen, setIsOpen, className, onClick, ...htmlProps } = props;
    const previousIsOpen = usePrevious(isOpen);
    assert(onClick == null || setIsOpen == null);
    const [isAnimating, setIsAnimating] = useState(false);
    useLayoutEffect(() => {
        if (previousIsOpen != null && isOpen != previousIsOpen) {
            setIsAnimating(true);
        }
    }, [isOpen, previousIsOpen]);
    const expandId = useId();
    const { onClick: buttonOnClick, ...buttonProps } = {
        onClick: (event) => {
            if (onClick != null) {
                onClick(event);
            }
            else if (setIsOpen != null) {
                setIsOpen(!isOpen);
            }
        },
        "aria-expanded": isOpen ? "true" : "false",
        "aria-controls": expandId,
    };
    return (React.createElement("div", { className: twMerge("flex h-fit w-fit flex-col", className), ...htmlProps },
        onClick != null || setIsOpen != null ? (React.createElement("button", { onClick: buttonOnClick, ...buttonProps }, children)) : (React.createElement("div", { ...buttonProps }, children)),
        React.createElement("div", { onTransitionEnd: (event) => {
                if (event.propertyName === "grid-template-rows") {
                    setIsAnimating(false);
                }
            }, className: twMerge("grid transition-all duration-300 ease-in-out", isOpen ? "grid-rows-[1fr]" : "grid-rows-[0fr]") }, (isOpen || isAnimating) && (React.createElement("div", { id: expandId, className: cn(isOpen && isAnimating && "-m-2 p-2", isAnimating && "overflow-y-hidden") }, expand)))));
};
export default ExpandableRow;
//# sourceMappingURL=ExpandableRow.js.map